// Frontend/src/api/voiceEntry.ts
import { APINodeClient } from './apiNodeCore';

const api = new APINodeClient();

// Submit audio entry to the backend
// export const submitAudioEntryApi = async (file: File) => {
//   const formData = new FormData();
//   formData.append('file', file);
//   return api.createWithFileForAudio('/api/voice/submit', formData); // 👈 Pass the correct formData
// };



export const submitAudioEntryApi = async ({ file, fileType }: { file: File; fileType: string }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', fileType); // ✅ append it as a field
  formData.append('fileName',"fileName");

  return api.createWithFileForAudio('/api/voice/submit', formData);
};


export const updateAudioEntryApi = async ({
  file,
  fileType,
  previousEntryResult,
}: {
  file: File;
  fileType: string;
  previousEntryResult?: any;
}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileType", fileType);

  if (previousEntryResult) {
    formData.append("entryResult", JSON.stringify(previousEntryResult)); // ✅ Send as JSON string
  }

  return api.createWithFileForAudio("/api/voice/update-audio-entry", formData);
};



export const approvedEntrySubmitApi = async (data: any) => {
  return api.create('/api/voice/approve-entry',data);
};